import i18next from 'i18next'
import pluralize, { PluralForms } from '@/libs/pluralize'
import { useTranslation } from 'react-i18next'
import { ModalPresetConfirm, ModalPresetConfirmProps } from '@dashboard/ui'

interface ConfirmPublishDialogProps extends Omit<ModalPresetConfirmProps, 'cancel' | 'submit' | 'title'> {
  confirmPublish: boolean
  count: number
  forms: PluralForms
  cancel: {
    callback: () => void
  }
  submit: {
    callback: () => void
  }
}

export default function ConfirmPublishDialog(props: ConfirmPublishDialogProps) {
  const entity = pluralize(props.count, props.forms, i18next.language)
  const { t } = useTranslation()

  return (
    <ModalPresetConfirm
      {...props}
      title={{
        children: t(!props.confirmPublish ? 'confirm.unpublish-n' : 'confirm.publish-n', {
          N: props.count,
          entity: entity,
        }),
        subtitle: t(!props.confirmPublish ? 'confirm.unpublish-n.message' : 'confirm.publish-n.message', {
          entity: entity,
        }),
      }}
      cancel={{
        label: t('Cancel'),
        callback: props.cancel.callback,
      }}
      submit={{
        callback: () => {
          props.submit?.callback()
          props.onClose()
        },
        color: 'danger',
        label: t(!props.confirmPublish ? 'unpublish' : 'publish', {
          N: props.count,
        }),
      }}
    />
  )
}
